import {
  withFormsy,
} from 'formsy-react';

import InputEmailView from './InputEmailView';

// @ts-expect-error form component
const InputComponent = withFormsy(InputEmailView);

const Component = InputComponent;

export default Component;
